import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=5153a23e&scoped=true"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5153a23e",
  null
  
)

export default component.exports